import { blue } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/styles';

export const useMeetingDetailsStyle = makeStyles((theme) => {
  return {
    acceptBtn: {
      marginRight: 6,
    },
    description: {
      whiteSpace: 'pre-line',
    },
    imageContainer: {
      maxWidth: 500,
      margin: 'auto',
    },
    meetingImage: {
      width: '100%',
      height: 'auto',
      display: 'block',
      borderRadius: 3,
    },
    table: {
      margin: '1rem 0',
    },
    memberList: {
      maxHeight: 200,
      overflowY: 'auto',
      marginBottom: '1rem',
    },
    avatar: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      marginRight: 16,
    },
    cardHeader: {
      backgroundColor: '#f7f7f7',
    },
    comment: {
      margin: '1rem',
    },
    commentAvatar: {
      width: theme.spacing(7),
      height: theme.spacing(7),
    },
    sendComment: {
      margin: '1rem auto',
    },
    icon: {
      marginRight: 4,
    },
    guest: {
      color: blue[900],
    },
    buttonProgress: {
      color: '#000',
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    submitBox: {
      display: 'flex',
      alignItems: 'center',
    },
    wrapper: {
      margin: '10px 0',
      position: 'relative',
    },
    label: {
      marginRight: 10,
    },
    copyLink: {
      cursor: 'pointer',
    },
    // wrapper: {
    //   position: 'relative',
    //   margin: '10px 0',
    //   width: 'max-content',
    //   display: 'flex',
    //   justifyContent: 'center',
    //   alignItems: 'center',
    // },
    // buttonProgress: {
    //   color: '#000',
    //   position: 'absolute',
    // },
  };
});
